import { makeStyles } from "@material-ui/styles";

export default makeStyles({
  root: {
    display: "block",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "#2D323D",
    zIndex: 99999,
    pointerEvents: "none",
  },
  center: {
    display: "block",
    width: "100%",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
  },
  centerContent: {
    display: "flex",
    justifyContent: "center",
  },
});
